import { z } from 'zod'

import { zodErrorMap } from '@/services/forms/zodErrorMap'

/** Maps every zod issue code to the app's field-error presentation keys, matching server 422 copy. */
export default defineNuxtPlugin(() => {
  z.config({ customError: zodErrorMap(usePresentationTranslator()) })
})
